import { tableTypes } from 'features/assistant/model/useControlPanel/data';
import { isArray } from 'lodash';

const initial = { rows: [], columns: [], type: null };

const parseNumber = value => {
  const normalizedValue = typeof value === 'string' ? value.trim().replace(',', '.') : value;
  const parsedValue = Number(normalizedValue);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

// Берем номер строки из ответа бэка.
const getRowNumero = row => row?.number;

// Для players_top оставляем нужный набор колонок и сортируем строки по номеру.
const normalizePlayersTop = rows =>
  [...rows]
    .sort((leftRow, rightRow) => parseNumber(getRowNumero(leftRow)) - parseNumber(getRowNumero(rightRow)))
    .slice(0, 10)
    .map(row => ({
      user_id: row.user_id,
      number: getRowNumero(row),
      username: row.username,
      bets_count: row.bets_count,
      bets_sum: row.bets_sum,
      wins_sum: row.wins_sum,
      profit: row.profit,
    }));

// Для deposits_top_players сортируем строки по сумме депозита по убыванию.
const normalizeDepositsTopPlayers = rows =>
  [...rows]
    .sort((leftRow, rightRow) => parseNumber(rightRow.deposits_amount) - parseNumber(leftRow.deposits_amount))
    .slice(0, 10);

const normalizeRows = (rows, action) => {
  if (action === 'players_top') return normalizePlayersTop(rows);
  if (action === 'deposits_top_players') return normalizeDepositsTopPlayers(rows);
  return rows.slice(0, 10);
};

export class AssistantConverter {
  convertTableData(data, action) {
    const keys = Object.keys(data);
    const values = Object.values(data);

    if (keys?.length === 0 || values?.length === 0) return initial;
    if (values?.length === 1 && isArray(values[0]) && values[0]?.length === 0) return initial;

    const firstValue = values[0];
    const children = isArray(firstValue) ? normalizeRows(firstValue, action) : firstValue;
    const isSingle = values.length === 1 && !isArray(firstValue);
    const hasChildren = isArray(children) && children.length > 0;

    if (hasChildren) {
      const childrenHeads = Object.keys(children[0]);
      const childrenRows = children.map(row => Object.values(row));
      const columns = childrenHeads.map((head, idx) => [head, ...childrenRows.map(cr => cr[idx])]);
      return { rows: [childrenHeads, ...childrenRows], columns, type: tableTypes?.list };
    }

    if (isArray(children) && !hasChildren) return initial;

    return { rows: [keys, values], columns: [], type: isSingle ? tableTypes?.single : tableTypes?.general };
  }
}
